export default __webpack_public_path__ + "static/media/goshen62.2eddef95.jpg";